import { api } from "../services/api";

const STORAGE_KEY = "referral_ref";

function writeReferral(ref) {
  const value = String(ref).trim();
  if (!value) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, value);
  } catch (_) {}
  try {
    localStorage.setItem(STORAGE_KEY, value);
  } catch (_) {}
}

export function captureReferralFromSearch(searchParams) {
  const ref =
    searchParams?.get?.("ref") ||
    new URLSearchParams(window.location.search).get("ref");
  if (ref) {
    writeReferral(ref);
    trackReferral(ref).catch(() => {});
  }
  return getStoredReferral();
}

export function getStoredReferral() {
  try {
    const fromSession = sessionStorage.getItem(STORAGE_KEY);
    if (fromSession) return fromSession;
  } catch (_) {}
  try {
    const fromLocal = localStorage.getItem(STORAGE_KEY);
    if (fromLocal) {
      // Mirror into session for the rest of this tab
      try {
        sessionStorage.setItem(STORAGE_KEY, fromLocal);
      } catch (_) {}
      return fromLocal;
    }
  } catch (_) {}
  return null;
}

export function withReferralQuery(path) {
  const ref = getStoredReferral();
  if (!ref) return path;
  const sep = path.includes("?") ? "&" : "?";
  return `${path}${sep}ref=${encodeURIComponent(ref)}`;
}

export async function trackReferral(ref) {
  if (!ref) return;
  await api.get("/referral/track", { params: { ref } });
}

export function appendReferralToPayload(payload) {
  const ref = getStoredReferral();
  return appendReferralCodeToPayload(payload, ref);
}

export function normalizeReferralCode(code) {
  const value = String(code ?? "").trim();
  return value ? value.toUpperCase() : "";
}

/** Attache le code promo saisi (champ formulaire) au payload d'inscription. */
export function appendReferralCodeToPayload(payload, referralCode) {
  const ref = normalizeReferralCode(referralCode);
  if (!ref) return payload;
  if (payload instanceof FormData) {
    payload.append("ref", ref);
    return payload;
  }
  return { ...payload, ref };
}

/** Message lisible pour les erreurs d'inscription API. */
export function formatRegisterError(
  err,
  fallback = "L'inscription a échoué. Vérifiez e-mail, téléphone et identifiant."
) {
  const data = err?.response?.data;
  if (data?.errors && typeof data.errors === "object") {
    for (const value of Object.values(data.errors)) {
      const msg = Array.isArray(value) ? value[0] : value;
      if (msg) return String(msg);
    }
  }
  return data?.message || data?.error || err?.message || fallback;
}

export function mapRegisterValidationErrors(err) {
  const be = err?.response?.data?.errors;
  if (!be || typeof be !== "object") return {};
  const mapped = {};
  Object.entries(be).forEach(([k, arr]) => {
    mapped[k] = Array.isArray(arr) ? arr[0] : String(arr);
  });
  return mapped;
}
